import turfObj from "@turf/centroid";

export default function centroid(features, options) {
    return turfObj(features, options);
};
